module.exports = __webpack_public_path__ + "img/toggle_menu-es.1660684c.png";